module.exports = __webpack_public_path__ + "static/media/support_groups.67f82156.svg";